// extracted by mini-css-extract-plugin
export default {"tooltip":"WM-z","arrow":"XM-z"};